import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./assets/app.less";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import RemoteConfigProvider from "./firebase/RemoteConfigProvider";

ReactDOM.render(
	<React.StrictMode>
		<RemoteConfigProvider defaults="hidden_features,cms_latest_version">
			<App />
		</RemoteConfigProvider>
	</React.StrictMode>,
	document.getElementById("root")
);

serviceWorkerRegistration.register();

if ("serviceWorker" in navigator) {
	navigator.serviceWorker
		.register("/firebase-messaging-sw.js")
		.then((registration) => {
			console.log("Service Worker registered with scope:", registration.scope);
		})
		.catch((error) => {
			console.error("Service Worker registration failed:", error);
		});
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
